
import { Form, Input, Skeleton, Button, Upload, Icon } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { createNewTicket, getTitles } from '../../Actions/HelpAction';
import { fileToBase64 } from '../../helpers/helpers';
import { uploadFile } from '../../Actions/FileManagerAction';
import { showError } from '../../Actions/VisualDataAction';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

const NewTicket = props => {

    const Dictionary = useSelector(state => state.VisualData.Dictionary);
    const LAN = useSelector(state => state.VisualData.LAN);
    const dispatch = useDispatch();

    const { getFieldDecorator } = props.form;

    const queryStringReserveId = queryString.parse(props.location.search)?.reserveId;

    const token = localStorage.getItem("userToken");

    const [types, setTypes] = useState();
    const [activeTypeId, setActiveTypeId] = useState();
    const [loading, setLoading] = useState(false);
    const [openSuccessModal, setOpenSuccessModal] = useState(false);

    const [fileList, setFileList] = useState([]);

    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'docx', 'xlsx', 'txt'];
    const acceptTypes = allowedExtensions.map((ext) => `.${ext}`).join(','); // Convert to ".pdf,.png,.jpg,..."

    useEffect(()=>{
        window?.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
    },[]);
    
    const firstType = types?.[0];
    useEffect(() => {
        if (firstType) {
            
            setActiveTypeId(firstType.id);
        }
    }, [firstType]);

    const titleIsRequired = types?.find(item => item.id === +activeTypeId)?.type === "WithSubject";

    const language = LAN === "IR" ? "fa-IR" : "en-US";

    useEffect(() => {
        const fetchTitles = async (t, lang) => {
            const response = await getTitles(t, lang);
            if (response.data?.result?.items) {
                setTypes(response.data.result.items);
            }
        }

        if (token && language) {
            fetchTitles(token, language);
        }

    }, [token, language]);

    const handleAttachments = async () => {
        const attachments = fileList.filter((f) => f.originFileObj).map((item) => item.originFileObj) || [];
        if (!attachments.length) return undefined;

        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB limit
        const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'docx', 'xlsx', 'txt'];

        const uploadPromises = attachments.map(async (attachment) => {
            if (!attachment.name || !attachment.size) {
                console.warn('Skipping file: Missing name or size');
                return Promise.resolve(null);
            }

            const trimmedName = attachment.name.trim();
            const lastDotIndex = trimmedName.lastIndexOf('.');

            // Extract the extension and normalize it to lowercase
            const fileExtension = lastDotIndex !== -1 ? trimmedName.substring(lastDotIndex + 1).toLowerCase() : '';

            // 🛑 Prevent hidden/system files (starting with a dot)
            if (trimmedName.startsWith('.')) {
                console.warn(`Skipping file: Hidden or system file (${trimmedName})`);
                return Promise.resolve(null);
            }

            // 🛑 Validate against allowed file extensions
            if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
                console.warn(`Skipping file: Unsupported file type (${fileExtension})`);
                return Promise.resolve(null);
            }

            // 🛑 Prevent empty files
            if (attachment.size === 0) {
                console.warn(`Skipping file: Empty file (${trimmedName})`);
                return Promise.resolve(null);
            }

            // 🛑 Prevent oversized files
            if (attachment.size > MAX_FILE_SIZE) {
                console.warn(`Skipping file: File size exceeds limit (${trimmedName}, ${attachment.size} bytes)`);
                return Promise.resolve(null);
            }

            const fileName = `${crypto.randomUUID()}.${fileExtension}`; // Generate safe filename

            const base64 = await fileToBase64(attachment);

            return uploadFile({
                fileName,
                file: base64.base64Content,
                type: 'Tickets',
            }, "IR",token);

        });

        const results = await Promise.all(uploadPromises);

        const attachmentIdList = results
            .filter((response) => response?.data?.result)
            .map((response) => ({
                fileUniqKey: response?.data?.result?.uniqKey,
                filePath: response?.data?.result?.uniqKey
            }));

        if (attachmentIdList.length !== attachments.length) {
            throw new Error('Failed to upload all attachments');
        }

        return attachmentIdList;

    }


    const SubmitHandler = async (e) => {

        e.preventDefault();

        props.form.validateFields(async (err, values) => {

            if (!err) {
                setLoading(true);
                try {
                    const attachmentIdList = await handleAttachments();

                    const params = {
                        reserveId: +values.reserveId,
                        title: values.title,
                        titleId: +activeTypeId,
                        messages: [{ message: values.Comment }],
                        attachments: attachmentIdList
                    }

                    const response = await createNewTicket(params, token, language);

                    if (response?.error) {
                        dispatch(
                            showError({
                                visibility: true,
                                content: response.error.message || "Internal Error,Please refresh the page",
                                closable: true
                            })
                        )
                    }

                    if (response?.data?.success) {
                        setOpenSuccessModal(true);
                    }

                    setLoading(false);

                } catch (error) {
                    console.error(error);
                }
            }
        });

    }

    const backToList = () => {
        props.history.push(`/profile?mode=tickets`);
    }

    return (
        <div className="section-vertical-padding">

            {openSuccessModal && (
                <div className="itours-modal visible" >
                    <div className="modal-overlay" onClick={() => { setOpenSuccessModal(false) }} />
                    <div className="modal-inner small-width">
                        <div className="modal-main text-center">
                            <div className="image text-center margin-bottom margin-top">
                                <span className={`icon-xlarge itours-icon check-green`} />
                            </div>
                            <p className="margin-bottom-large">
                                {Dictionary.NewTicketSuccessfullyRegistered}
                            </p>
                            <button
                                type="button"
                                className="button blue-btn margin-bottom"
                                onClick={backToList}
                            >
                                {Dictionary.ok}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="page-container">

                <h2 className="medium-title"> {Dictionary.CreateNewTicket}</h2>

                <Form onSubmit={SubmitHandler} className='margin-bottom-large' >

                    <p className="margin-bottom-large">
                        {Dictionary.CompleteTheFormToSendYourRequest}.
                    </p>

                    <div className="float-row margin-bottom">
                        <div className="col-small-12 col-medium-6">

                            <Form.Item label={Dictionary.ReservationNumber} className="form-group">
                                {getFieldDecorator('reserveId', {
                                    initialValue: queryStringReserveId || "",
                                })(
                                    <Input
                                        className="form-input"
                                        placeholder={Dictionary.ReservationNumber}
                                        disabled={!!queryStringReserveId}
                                    />,
                                )}
                            </Form.Item>

                            {types?.length ? (
                                <Form.Item label={Dictionary.type} className="form-group">
                                    {getFieldDecorator('typeId')(
                                        <select
                                            className="h-40"
                                            onChange={e => { setActiveTypeId(e.target.value) }}
                                        >
                                            {types?.map(item => <option key={item.id} value={item.id}>
                                                {item.title}
                                            </option>)}
                                        </select>,
                                    )}
                                </Form.Item>) : (
                                <>
                                    <Skeleton active paragraph={{ rows: 0 }} className="one-line-skeleton margin-bottom" />
                                    <Skeleton active paragraph={{ rows: 0 }} className="one-line-skeleton margin-bottom-large" />
                                </>

                            )}

                            {titleIsRequired && (
                                <Form.Item label={Dictionary.subject} className="form-group">
                                    {getFieldDecorator('title')(
                                        <Input
                                            className="form-input"
                                            placeholder={Dictionary.subject}
                                        />,
                                    )}
                                </Form.Item>
                            )}

                            <Form.Item label={Dictionary.messageText} className="form-group">
                                {getFieldDecorator('Comment', {
                                    rules: [{ required: true, message: Dictionary.thisFieldIsRequired }],
                                })(
                                    <textarea placeholder={Dictionary.messageText} className="full-width form-input hotel-comment-textarea"></textarea>
                                )}
                            </Form.Item>

                            <br />
                            <Upload
                                className='upload-files'
                                fileList={fileList}
                                multiple
                                beforeUpload={() => false}
                                onChange={data => { setFileList(data.fileList); }}
                                accept={acceptTypes}
                            >
                                <Button>
                                    <Icon type="upload" /> {Dictionary.UploadFile}
                                </Button>
                            </Upload>

                        </div>
                    </div>

                    <button type='submit' className='button blue-btn'> {Dictionary.send}
                        {loading && <span className="loading-inline-circle margin-start-light" />}  </button>
                </Form>

            </div>
        </div>
    )
}

const NewTicketForm = Form.create({ name: 'newTicket' })(NewTicket);

export default withRouter(NewTicketForm);